import React from 'react';
import './RadioButton.css';
/**
 * @param {React.JSX.Element} param.children Make sure is a single node
 */
const RadioButton = ({
  checked = false,
  children,
  containerClassName = '',
  id = '',
  name = '',
  onChange = () => { },
  ...radioProps
}) => (
  // Disabled rule 'cause this structure replace the htmlFor attr
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label
    className={`Radio-button ${containerClassName}`}
    id={`${id}-label`}
  >
    <input
      checked={checked}
      id={id}
      name={name}
      onChange={onChange}
      type="radio"
      {...radioProps}
    />

    {children}
  </label>
);

export { RadioButton };
